'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../../node_modules/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["className", "children", "center", "start", "end", "around", "between"];

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      children = props.children,
      center = props.center,
      start = props.start,
      end = props.end,
      around = props.around,
      between = props.between,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var classes = index$1['default']('modal-footer', className, {
    'justify-content-start': start,
    'justify-content-end': end,
    'justify-content-center': center,
    'justify-content-between': between,
    'justify-content-around': around
  });
  return /*#__PURE__*/React__default['default'].createElement("div", _extends['default']({
    "data-test": "modal-footer"
  }, attributes, {
    className: classes
  }), children);
};

ModalFooter.propTypes = {
  children: index['default'].node,
  className: index['default'].string
};
exports.ModalFooter = ModalFooter;
exports['default'] = ModalFooter;